import axios from 'axios'
import { ElMessage } from 'element-plus'
import store from '@/store'
import router from '@/router'

// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 15000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 从 store 中获取 token
    const token = store.state.user.token
    if (token) {
      // 除了登录接口，其他接口都需要带上 token
      config.headers['ats-token'] = token
    }
    return config
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data

    // 兼容旧接口:如果返回的是字符串(token),直接返回
    if (typeof res === 'string') {
      return res
    }

    // 新的统一返回格式处理
    // 后端所有接口现在返回 {code, message, data} 格式
    // HTTP状态码始终为200,通过code字段判断业务成功与否
    if (res.code !== undefined) {
      // 根据 code 判断请求是否成功
      if (res.code === 200) {
        // 成功,返回 data 部分
        return res.data
      } else {
        // 失败,根据不同错误码做不同处理
        if (res.code === 401) {
          ElMessage.error(res.message || '登录已过期,请重新登录')
          // 清除 token,跳转到登录页
          store.dispatch('user/logout')
          router.push('/login')
        } else if (res.code === 400 && res.message && (res.message.includes('token无效') || res.message.includes('未授权'))) {
          // 处理 token 失效的情况 (code: 400)
          ElMessage.error(res.message || 'Token已失效,请重新登录')
          // 清除 token,跳转到登录页
          store.dispatch('user/logout')
          router.push('/login')
        } else if (res.code === 403) {
          ElMessage.error(res.message || '没有权限访问')
        } else if (res.code === 404) {
          ElMessage.error(res.message || '请求的资源不存在')
        } else if (res.code === 500) {
          ElMessage.error(res.message || '系统内部错误')
        } else {
          // 其他业务错误 (如 400 等)
          // 检查是否包含敏感信息（SQL 错误、异常堆栈等）
          const sensitiveKeywords = [
            'SQLException',
            'Error updating database',
            'Error parsing',
            'NullPointerException',
            'IndexOutOfBoundsException',
            'ClassCastException',
            'IllegalArgumentException',
            'doesn\'t have a default value',
            'Table',
            'Column',
            'SQL:',
            '### Error',
            'stack trace',
            'at com.',
            'at java.',
            'at org.',
            'at sun.'
          ]
          
          // 如果消息包含敏感信息，显示友好提示
          const isSensitiveError = sensitiveKeywords.some(keyword => 
            res.message && res.message.includes(keyword)
          )
          
          if (isSensitiveError) {
            ElMessage.error('系统开小差了，请稍后再试')
          } else {
            ElMessage.error(res.message || '请求失败')
          }
        }
        return Promise.reject(new Error(res.message || '请求失败'))
      }
    }

    // 兼容旧接口:如果没有code字段,直接返回原数据
    return res
  },
  error => {
    console.error('响应错误:', error)

    // 网络错误或其他非业务错误(如超时、网络中断等)
    if (error.response) {
      // 服务器有响应但出现网络层错误
      const res = error.response.data
      if (res && res.message) {
        // 检查是否包含敏感信息
        const sensitiveKeywords = [
          'SQLException',
          'Error updating database',
          'Error parsing',
          'NullPointerException',
          'doesn\'t have a default value'
        ]
        
        const isSensitiveError = sensitiveKeywords.some(keyword => 
          res.message && res.message.includes(keyword)
        )
        
        if (isSensitiveError) {
          ElMessage.error('系统开小差了，请稍后再试')
        } else {
          ElMessage.error(res.message)
        }
      } else {
        ElMessage.error('服务器响应异常')
      }
    } else if (error.request) {
      // 请求已发出但没有收到响应
      ElMessage.error('网络错误,请检查您的网络连接')
    } else {
      // 请求配置错误
      ElMessage.error(error.message || '请求配置错误')
    }

    return Promise.reject(error)
  }
)

export default service


